import { DownloadIcon } from "../../Icons"
import '../index.css'

interface DownloadChipProps {
  onClick?: () => void
  label?: string
  disabled?: boolean
}

const DownloadChip: React.FC<DownloadChipProps> = ({ onClick, label, disabled }) => {

  return (
    <div>
      <button disabled={disabled} className="chip-btn" onClick={onClick}>
        <DownloadIcon className="chip-btn__icon" />
        {label}
      </button>
    </div>
  )
}

export default DownloadChip